import { BaseControlTheme } from './base-control.theme'
import { ButtonTheme } from './button.theme'
import { FormTheme } from './form.theme'
import { InputTheme } from './input.theme'
import { LinkTheme } from './link.theme'
import { SelectTheme } from './select.theme'
import { SkeletonTheme } from './skeleton.theme'

export const components = {
  Button: ButtonTheme,
  Form: FormTheme,
  Input: InputTheme,
  Select: SelectTheme,
  Link: LinkTheme,
  Skeleton: SkeletonTheme,
  BaseControl: BaseControlTheme
}
